import React, { useEffect, useState } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import DollarIMacIcon from '../../../../icons/dollar-imac.svg';
import { makeStyles } from "@material-ui/core/styles";
import './HealthClassCalcStackedButton.scss'
import HealthClassCalc from './HealthClassCalc';
import HealthNotesIcon from '../../../../icons/health-notes.svg';
import { Button } from '@material-ui/core';

const white = "#ffffff";
const offWhite = "rgba(0, 0, 0, 0.01)"

const useStyles = makeStyles(theme => ({
  white: {
    color: theme.palette.primary.main,
    backgroundColor: white,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: offWhite
    },
    '&:focus': {
      outline: 'none'
    }
  },
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },

}));

export default function HealthClassCalcStackedButton(props) {
  const classes = useStyles();

  const title = props.title || "NEEDS ANALYSIS";
  const toolName = props.toolName;

  const [modalHealthCalcIsOpen, setModalHealthCalcIsOpen] = useState(false);

  const modalNeedsCalculatorFields = {
    modalHealthCalcIsOpen: modalHealthCalcIsOpen,
    setModalHealthCalcIsOpen: setModalHealthCalcIsOpen,
  };

  return (
    <div className="health-rating-stacked-button">
    <Button type="submit"
          onClick={() => setModalHealthCalcIsOpen(true)}
          variant={props.isPrequote ? undefined : "contained"}
          color="primary"
          className={`quote-health-button ${classes.white}`}
        >
          {props.isPrequote ? <SvgIcon component={HealthNotesIcon} color="primary" /> : <div className={`icon-container mb-0 ${classes.lightBackground}`}><SvgIcon component={DollarIMacIcon} color="primary" /></div>}
          <h3 className="tool-name">{toolName}</h3>
          <span className="name">&nbsp;{title}</span>
        </Button>
      <HealthClassCalc fields={modalNeedsCalculatorFields} isPrequote={props.isPrequote} currentHealthClass={props.currentHealthClass} onHealthClassChange={props.onHealthClassChange} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/HealthClassCalculator/HealthClassCalcStackedButton.js